import { Routes } from '@angular/router';

import { loadChangePasswordPage } from '@auth-pages';
import { getClientUrl } from '@core';
import { authGuard, errorGuard, testGuard } from '@guards';
import { loadAccessibilityPage, loadCookiesPage, loadErrorPage, loadLandpage, loadTestdevPage } from '@pages';
import { backButtonResolver, moduleResolver } from '@resolvers';

export let routes: Routes = [];

const clientUrl = getClientUrl();

if (clientUrl.length) {
    routes = [
        // Must come first: the next route also matches `/client` (no child) and would render nothing.
        { path: clientUrl, pathMatch: 'full', redirectTo: `/${clientUrl}/signIn` },
        {
            path: `${clientUrl}`,
            children: [
                {
                    path: 'landpage',
                    loadComponent: loadLandpage,
                    title: 'Apas One - Select module',
                    data: { moduleName: 'LANDPAGE' },
                    resolve: { module: moduleResolver, backButton: backButtonResolver },
                },
                {
                   path: 'testdev',
                   loadComponent: loadTestdevPage,
                   title: 'Test development',
                   canActivate: [testGuard]
                },
                {
                    path: 'login-details',
                    loadComponent: loadChangePasswordPage,
                    title: 'Login details',
                    canActivate: [authGuard]
                },
                {
                    path: 'accessibility',
                    loadComponent: loadAccessibilityPage,
                    title: 'Accessibility',
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'cookies',
                    loadComponent: loadCookiesPage,
                    title: 'Cookies',
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'error',
                    loadComponent: loadErrorPage,
                    title: 'Error',
                    canActivate: [errorGuard]
                },
            ]
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@auth-pages').then(r => r.IdentityRoutes),
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@apas-one/modules/modules.routes').then(r => r.ModulesRoutes),
        },
        { path: '**', redirectTo: `${clientUrl}/signIn`, pathMatch: 'full' }
    ];
}
else {
    routes = [{ path: '**', redirectTo: 'error', pathMatch: 'full' }];
    console.error('Client not found');
}
